module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_02.dot-c83517bdf3f43f8974bb13882fdad4aa.svg";